// extracted by mini-css-extract-plugin
export default {"progressContainerWrapper":"levelscoring_progressContainerWrapper__c3Lgb","progressTextContainer":"levelscoring_progressTextContainer__ZqHV6"};